module.exports = __webpack_public_path__ + "img/reg-icon.d0c0ac98.svg";